import MainLayout from './main';

const content =
  '<div id="app" :class="cityClass"><MainLayout :ads="ads" :clientId="clientId" :showid="showid" :apiOrigin="apiOrigin" :channels="channels"><div slot="bottom"><slot name="bottom"></slot></div><div slot="main"><slot></slot></div></MainLayout></div>';

const template = `<!DOCTYPE html>
<html lang="en">
<head>
  <title>{{vTitle}}</title>
  <meta name="keywords" :content="vKeywords">
  <meta name="description" :content="vDescription">
  <meta http-equiv="content-type" content="text/html;charset=utf-8">
  <link rel="shortcut icon" href="/favicon.ico" type="image/x-icon" />
</head>
<body  :style="baseClass">
  <div  id="app" >${content}</div>
</body>
</html>`;

export default {
  name: 'Layout',
  props: {
    setTitle: {
      default: false
    },
    apiOrigin: {
      default: ''
    },
    description: {},
    showid: {
      default: -2
    },
    clientId: {},
    ads: {
      default: () => ({
        banner1: {},
        banner2: {},
        banner3: {},
        duration: 0,
        slide: {},
        slideBars: []
      })
    },
    keywords: {},
    channels: {
      default: []
    }
  },
  components: {
    MainLayout
  },
  data() {
    return {
      title: { 320598: { name: '吴江新闻网' } },
      baseStyle: {
        320598: {}
      }
    };
  },
  mounted () {
    console.log('apiOrigin', this.apiOrigin)
  },
  computed: {
    vTitle() {
      if (!this.setTitle) {
        return this.title[this.clientId].name;
      } else {
        return this.setTitle;
      }
    },
    vKeywords() {
      return this.$root.keywords || this.keywords || '';
    },
    vDescription() {
      return (
        this.$root.description ||
        this.description ||
        'egg-vue-webpack server side render'
      );
    },
    cityClass() {
      let cityCls = this.$root.cityClass;
      return cityCls;
    },
    baseClass() {
      return this.baseStyle[this.clientId];
    }
  },
  template: typeof window === 'object' ? content : template
};



// WEBPACK FOOTER //
// ./app/web/component/web/news-layout/index.js